<template>
  <v-dialog
    v-model="open"
    :width="width"
    :max-width="maxWidth"
    @keydown.esc="onCancel"
    @click:outside="!persistent && onCancel()"
    :persistent="persistent"
  >
    <v-card :class="cardClass">
      <v-card-title v-if="title" class="text-h6 d-flex align-center">
        <v-icon v-if="icon" class="mr-2" :color="iconColor">{{ icon }}</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-subtitle v-if="subtitle" class="pt-2">
        {{ subtitle }}
      </v-card-subtitle>

      <v-card-text class="pt-4">
        <slot name="content" />
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" @click="onCancel" :aria-label="cancelLabel">
          {{ cancelLabel }}
        </v-btn>
        <slot name="actions"></slot>
        <v-btn text :color="primaryActionColor" :loading="loading" @click="onPrimaryAction" :aria-label="primaryActionLabel">
          {{ primaryActionLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Weet je het zeker?",
    },
    subtitle: {
      type: String,
      default: null,
    },
    width: {
      type: [String, Number],
      default: "auto",
    },
    maxWidth: {
      type: [String, Number],
      default: "600",
    },
    cardClass: {
      type: String,
      default: "",
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
    iconColor: {
      type: String,
    },
    cancelLabel: {
      type: String,
      default: "Annuleren",
    },
    primaryActionLabel: {
      type: String,
      default: "Verwijderen",
    },
    primaryActionColor: {
      type: String,
      default: "error",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "open",
    event: "toggle",
  },
  methods: {
    onCancel() {
      this.$emit("toggle", false);
      this.$emit("cancel");
    },
    onPrimaryAction() {
      this.$emit("agree");
    },
  },
};
</script>
